// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.points-container {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.points-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}

.points-header h1 {
  margin: 0;
  color: #fff;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.add-btn {
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.add-btn.positive {
  background: #43b581;
}

.add-btn.positive:hover {
  background: #3ca374;
}

.add-btn.negative {
  background: #f04747;
}

.add-btn.negative:hover {
  background: #d84040;
}

.balance-card {
  background: linear-gradient(135deg, #5865f2 0%, #7289da 100%);
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  margin-bottom: 25px;
}

.balance-label {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

.balance-amount {
  color: #fff;
  font-size: 56px;
  font-weight: bold;
  line-height: 1;
}

.balance-unit {
  color: rgba(255, 255, 255, 0.9);
  font-size: 18px;
  margin-top: 5px;
}

.tab-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.tab-buttons button {
  background: #2f3136;
  color: #b9bbbe;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tab-buttons button.active,
.tab-buttons button:hover {
  background: #5865f2;
  color: white;
}

.history-section,
.leaderboard-section {
  background: #2f3136;
  border-radius: 8px;
  padding: 20px;
}

.history-section h2,
.leaderboard-section h2 {
  color: #fff;
  margin: 0 0 20px 0;
  font-size: 18px;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.history-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 12px;
  background: #36393f;
  border-radius: 6px;
  border-left: 4px solid;
}

.history-item.positive {
  border-left-color: #43b581;
}

.history-item.negative {
  border-left-color: #f04747;
}

.history-amount {
  font-size: 20px;
  font-weight: bold;
  min-width: 80px;
  text-align: right;
}

.history-item.positive .history-amount {
  color: #43b581;
}

.history-item.negative .history-amount {
  color: #f04747;
}

.history-details {
  flex: 1 1;
}

.history-reason {
  color: #dcddde;
  font-size: 14px;
}

.history-date {
  color: #72767d;
  font-size: 12px;
  margin-top: 2px;
}

.leaderboard-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.leaderboard-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px;
  background: #36393f;
  border-radius: 6px;
}

.leaderboard-item.top-three {
  background: linear-gradient(90deg, #36393f 0%, #40444b 100%);
}

.rank {
  width: 40px;
  text-align: center;
}

.medal {
  font-size: 24px;
}

.rank-number {
  color: #72767d;
  font-size: 18px;
  font-weight: bold;
}

.user-info {
  flex: 1 1;
}

.user-id {
  color: #dcddde;
  font-size: 14px;
}

.points-value {
  color: #faa61a;
  font-weight: bold;
  font-size: 16px;
}

.no-data {
  text-align: center;
  color: #72767d;
  padding: 40px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #36393f;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  max-width: 400px;
}

.modal h2 {
  color: #fff;
  margin: 0 0 20px 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  color: #b9bbbe;
  margin-bottom: 5px;
  font-size: 13px;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 10px 20px;
  background: #40444b;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn {
  padding: 10px 20px;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn.positive {
  background: #43b581;
}

.submit-btn.positive:hover {
  background: #3ca374;
}

.submit-btn.negative {
  background: #f04747;
}

.submit-btn.negative:hover {
  background: #d84040;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #40444b;
  border-top-color: #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Points.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".points-container {\n  padding: 20px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.points-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.points-header h1 {\n  margin: 0;\n  color: #fff;\n}\n\n.header-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.add-btn {\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.add-btn.positive {\n  background: #43b581;\n}\n\n.add-btn.positive:hover {\n  background: #3ca374;\n}\n\n.add-btn.negative {\n  background: #f04747;\n}\n\n.add-btn.negative:hover {\n  background: #d84040;\n}\n\n.balance-card {\n  background: linear-gradient(135deg, #5865f2 0%, #7289da 100%);\n  border-radius: 12px;\n  padding: 30px;\n  text-align: center;\n  margin-bottom: 25px;\n}\n\n.balance-label {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 10px;\n}\n\n.balance-amount {\n  color: #fff;\n  font-size: 56px;\n  font-weight: bold;\n  line-height: 1;\n}\n\n.balance-unit {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 18px;\n  margin-top: 5px;\n}\n\n.tab-buttons {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.tab-buttons button {\n  background: #2f3136;\n  color: #b9bbbe;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.tab-buttons button.active,\n.tab-buttons button:hover {\n  background: #5865f2;\n  color: white;\n}\n\n.history-section,\n.leaderboard-section {\n  background: #2f3136;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.history-section h2,\n.leaderboard-section h2 {\n  color: #fff;\n  margin: 0 0 20px 0;\n  font-size: 18px;\n}\n\n.history-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.history-item {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 12px;\n  background: #36393f;\n  border-radius: 6px;\n  border-left: 4px solid;\n}\n\n.history-item.positive {\n  border-left-color: #43b581;\n}\n\n.history-item.negative {\n  border-left-color: #f04747;\n}\n\n.history-amount {\n  font-size: 20px;\n  font-weight: bold;\n  min-width: 80px;\n  text-align: right;\n}\n\n.history-item.positive .history-amount {\n  color: #43b581;\n}\n\n.history-item.negative .history-amount {\n  color: #f04747;\n}\n\n.history-details {\n  flex: 1;\n}\n\n.history-reason {\n  color: #dcddde;\n  font-size: 14px;\n}\n\n.history-date {\n  color: #72767d;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.leaderboard-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.leaderboard-item {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 15px;\n  background: #36393f;\n  border-radius: 6px;\n}\n\n.leaderboard-item.top-three {\n  background: linear-gradient(90deg, #36393f 0%, #40444b 100%);\n}\n\n.rank {\n  width: 40px;\n  text-align: center;\n}\n\n.medal {\n  font-size: 24px;\n}\n\n.rank-number {\n  color: #72767d;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.user-info {\n  flex: 1;\n}\n\n.user-id {\n  color: #dcddde;\n  font-size: 14px;\n}\n\n.points-value {\n  color: #faa61a;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.no-data {\n  text-align: center;\n  color: #72767d;\n  padding: 40px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #36393f;\n  border-radius: 8px;\n  padding: 20px;\n  width: 100%;\n  max-width: 400px;\n}\n\n.modal h2 {\n  color: #fff;\n  margin: 0 0 20px 0;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  color: #b9bbbe;\n  margin-bottom: 5px;\n  font-size: 13px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  background: #40444b;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn.positive {\n  background: #43b581;\n}\n\n.submit-btn.positive:hover {\n  background: #3ca374;\n}\n\n.submit-btn.negative {\n  background: #f04747;\n}\n\n.submit-btn.negative:hover {\n  background: #d84040;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #40444b;\n  border-top-color: #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
